
import runes from "../data/runes";

function getMaxRuneLevel(runeword) {
  const levels = runeword.runes.map(r => runes[r].level);
  const max = levels.reduce((a,b) => Math.max(a,b));
  return max;
}

export default getMaxRuneLevel;